export const Required = value => {
    return !value ? 'Field is required' : undefined;
}

export const RequiredNotBlank = value => {
    return !value ? 'Field is required' : !value.trim() ? 'Field is required' : undefined;
}

